import { BasketItem, IBasket, IBasketData } from ".";
import { IBasketItem } from "./basket.type";

export class Basket implements IBasket {
    basketId?: string;
    creationTime?: number;
    basketName?: string;
    ownerId: string;
    productList: IBasketItem[] = [];
    branchId: string;
    subTotal?: number;
    grandTotal?: number;
    bogoDiscount?: number;
    cartDiscount?: number;
    couponCodeList?: string[] = [];
    id?: string;
    saleID?: string;


    constructor(data: IBasketData) {
        this.basketId = data.basketId
        this.creationTime = data.creationTime
        this.basketName = data.basketName
        this.ownerId = data.ownerId
        this.productList = (data.productList.map(item => new BasketItem(item)))
        this.branchId = data.branchId
        this.subTotal = data.subTotal
        this.grandTotal = data.grandTotal
        this.bogoDiscount = data.bogoDiscount
        this.cartDiscount = data.cartDiscount
        if (data.couponCodeList) {
            this.couponCodeList = (data.couponCodeList.map((i) => i))
        }
        this.id = data.id;
        this.saleID = data.saleID;
    }
    data(): IBasketData {
        return Object.assign({}, this)
    }
}